import * as React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

export default function PageHeader(props) {
  return (
    <Grid
      container
      sx={{
        flexDirection: 'row',
        justifyContent: 'space-between',
        paddingBottom: '1rem',
      }}
    >
      <div>
        <Typography gutterBottom variant="h5" component="div">
          {props.title}
        </Typography>
        {props?.subTitle}
      </div>
      <div>
        {props.children}
      </div>
    </Grid>
  );
}
